
export default {
  data() {
    return {
      componentRendered: false,
    };
  },

  computed: {
  },

  created() {
    // console.info('created (tracking)...')
  },
  mounted() {
    // console.info('mounted (tracking)...')
    // this.setEventTrackingListeners();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  updated() {
    // console.info('updated (tracking)...')
    this.componentRendered = true
  },

  head() {
    return {
    title: this.pageData?.PageMeta?.Title || this.$t('page_meta.home.title'),
    meta: [
      {
        hid: 'og:title', name: 'og:title', property: 'og:title',
        content: this.pageData?.PageMeta?.Title || this.$t('page_meta.home.title'),
      },
      {
        hid: 'og:description', name: 'og:description', property: 'og:description',
        content: this.pageData?.PageMeta?.Description || this.$t('page_meta.home.description'),
      },
      {
        hid: 'description', name: 'description',
        content: this.pageData?.PageMeta?.Description || this.$t('page_meta.home.description'),
      },
      {
        hid: 'og:image', name: 'og:image',  property: 'og:image',
        content: this.pageData?.PageMeta?.Image?.url,
      },
    ]
    }
  },

  watch: {
  }
};
